import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, Bell, FileText, Users, Zap, ShieldAlert } from 'lucide-react';

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

const item = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: 'easeOut' } },
};

export const Features = () => {
  const features = [
    {
      icon: CreditCard,
      title: 'Pengelolaan Iuran Otomatis',
      description: 'Sistem mencatat dan mengelola pembayaran iuran secara otomatis. Terintegrasi dengan berbagai metode pembayaran digital.',
      highlights: ['Auto-record pembayaran', 'Multiple payment gateway', 'Riwayat transaksi lengkap']
    },
    {
      icon: Bell,
      title: 'Notifikasi Pembayaran',
      description: 'Kirim pengingat otomatis ke warga via WhatsApp, email dan Apps. Customizable sesuai kebutuhan kompleks Anda.',
      highlights: ['WhatsApp, Email & Apps notification', 'Jadwal pengingat otomatis', 'Template pesan custom']
    },
    {
      icon: FileText,
      title: 'Laporan Keuangan',
      description: 'Generate laporan pemasukan IPL lengkap dengan satu klik. Export ke Excel atau PDF untuk keperluan rapat atau audit.',
      highlights: ['Dashboard real-time', 'Export Excel & PDF', 'Grafik & visualisasi data']
    },
    {
      icon: Users,
      title: 'Manajemen Warga',
      description: 'Database warga terpusat dengan informasi lengkap. Mudah update data dan pantau status pembayaran setiap unit.',
      highlights: ['Database terpusat', 'Status pembayaran per unit', 'Import/export data warga']
    },
    {
      icon: Zap,
      title: 'Add On PPOB',
      description: 'Warga bisa bayar tagihan listrik, air, pulsa dan internet langsung dari aplikasi. Tambahan layanan sekaligus sumber pemasukan pengurus.',
      highlights: ['Listrik, air, pulsa & data', 'Top up e-wallet', 'Riwayat transaksi PPOB']
    },
    {
      icon: ShieldAlert,
      title: 'Informasi Warga',
      description: 'Pusat informasi dan layanan warga dalam satu tempat. Lapor tamu, kontak darurat, sampai pengajuan perizinan tanpa perlu ke pos.',
      highlights: ['Lapor tamu & kunjungan', 'Kontak darurat cepat', 'Pengajuan perizinan online']
    }
  ];

  return (
    <section id="features" className="py-20 bg-gradient-to-br from-brand-50 to-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-6">
            Fitur <span className="text-brand-700">Unggulan</span>
          </h2>
          <p className="text-lg text-foreground/70">
            Semua yang Anda butuhkan untuk mengelola IPL kompleks dalam satu platform
          </p>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="grid grid-cols-1 lg:grid-cols-3 gap-8"
        >
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                variants={item}
                whileHover={{ y: -4 }}
                className="group bg-card rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-border hover:border-brand-200"
              >
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-brand-700 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon className="text-white" size={32} />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-foreground mb-3">{feature.title}</h3>
                    <p className="text-foreground/70 mb-4 leading-relaxed">{feature.description}</p>
                    <ul className="space-y-2">
                      {feature.highlights.map((highlight, idx) => (
                        <li key={idx} className="flex items-center text-sm text-foreground/80">
                          <div className="w-1.5 h-1.5 bg-gold-500 rounded-full mr-3"></div>
                          {highlight}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
